class ProductBundle extends HTMLElement {
    constructor() {
        super();

        // Bind methods
        this.updateBundleTotalPrice = this.updateBundleTotalPrice.bind(this);

        // Initial update of bundle price
        this.updateBundleTotalPrice();
    }

    // Function to update bundle total price
    updateBundleTotalPrice() {
        const bundleItems = this.querySelectorAll('.bundle-product-item'); // Include all bundle product items
        const maxProduct = bundleItems.length; // Correctly count all items
        let totalPrice = 0;

        // Calculate total price of all items
        bundleItems.forEach((item) => {
            const selectElement = item.querySelector('select[name=group_id]');
            const inputElement = item.querySelector('input[name=group_id]');
            let price = 0;

            if (selectElement) {
                const selectedOption = selectElement.options[selectElement.selectedIndex];
                if (selectedOption) {
                    price = parseFloat(selectedOption.getAttribute('data-price'));
                    if (isNaN(price)) {
                        console.warn('Invalid price in select element', selectedOption);
                    }
                }
            } else if (inputElement) {
                price = parseFloat(inputElement.getAttribute('data-price'));
                if (isNaN(price)) {
                    console.warn('Invalid price in input element', inputElement);
                }
            } else {
                const idInputElement = item.querySelector('input[name=id]');
                if (idInputElement) {
                    price = parseFloat(idInputElement.getAttribute('data-price'));
                    if (isNaN(price)) {
                        console.warn('Invalid price in id input element', idInputElement);
                    }
                }
            }

            if (!isNaN(price)) {
                totalPrice += price;
            } else {
                console.warn('Price not added to total due to invalid value', price);
            }
        });

        

        // Access bundlePrice and oldPrice within the main scope of the method
        const bundlePriceElement = this.querySelector('.bundle-price');
        const oldPriceElement = this.querySelector('.bundle-old-price');

        // Check if bundlePriceElement and oldPriceElement are defined and accessible
        if (bundlePriceElement && oldPriceElement) {
            const discountRate = parseFloat(bundlePriceElement.getAttribute('data-bundle-discount-rate')) || 0;
            if (isNaN(discountRate) || discountRate < 0 || discountRate > 1) {
                console.warn('Invalid discount rate', discountRate);
                discountRate = 0;
            }
            // Calculate discounted price
            const discountedPrice = totalPrice * (1 - discountRate);

            console.log('Discount Rate:', discountRate);
            console.log('Discounted Price:', discountedPrice);

            // Update HTML content
            oldPriceElement.innerHTML = Shopify.formatMoney(totalPrice, window.money_format);
            bundlePriceElement.innerHTML = Shopify.formatMoney(discountedPrice, window.money_format);

            // Update total price display element
            const bundleTotalElement = this.querySelector('[data-bundle-product-total]');
            if (bundleTotalElement) {
                bundleTotalElement.innerHTML = Shopify.formatMoney(discountedPrice, window.money_format);
            }
        } else {
            console.warn('bundlePriceElement or oldPriceElement not found');
        }

        // Update 'Add to Cart' button text
        const addToCartButton = this.querySelector('[data-bundle-addtocart]');
        if (addToCartButton) {
            addToCartButton.value = window.total_btn.add_all_item;
        } else {
            console.warn('addToCartButton not found');
        }
    }
}

customElements.define('product-bundle', ProductBundle);
